module.exports = __webpack_public_path__ + "img/aeroland-branding-box-image-01-180x180.766848ce.png";